export default __webpack_public_path__ + "static/media/sambal-fried-rice.df903eaa.png";